import React from 'react';
import noop from 'lodash/noop';

type XPattern = [number];
type XYPattern = [number, number];
type XYZPattern = [number, number, number];

export type TParallaxTranslatePattern = XPattern | XYPattern | XYZPattern;

export type TParallaxLayerOptions = {
    // TODO доработать типизацию, добавить гибкий обьект для настройки cмещения
    $translateOffset: TParallaxTranslatePattern,
    $translateOffsetStart: TParallaxTranslatePattern,
    $perspective: number,
}

export type TParallaxLayer = TParallaxLayerOptions & {
    element: HTMLElement | null,
}

export type TAddLayer = (layer: TParallaxLayer) => void;

export type TParallaxContext = {
    addLayer: TAddLayer,
}

export const ParallaxContext = React.createContext<TParallaxContext>({
    addLayer: noop,
});
